/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerSelectiveAddendumDownloadMutationResponse } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerSelectiveAddendumDownload";

function getMultiDocumentAgentControllerSelectiveAddendumDownloadUrl() {
  const res = { method: 'POST', url: `/api/v1/multi-document-agent/selective-addendum-download` as const }  
  return res
}

/**
 * @description Rebuilds the addendum DOCX (or PDF) containing only the accepted amendments. Undecided and rejected amendments are excluded.
 * @summary Download an addendum rebuilt from only the accepted amendments
 * {@link /api/v1/multi-document-agent/selective-addendum-download}
 */
export async function multiDocumentAgentControllerSelectiveAddendumDownload(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerSelectiveAddendumDownloadMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getMultiDocumentAgentControllerSelectiveAddendumDownloadUrl().url.toString(), ... requestConfig })  
  return res.data
}